export default {
  mtDataTimePicker: {
    ["年"]: "year",
    ["月"]: "month",
    ["日"]: "day",
    ["时"]: "h",
    ["分"]: "minutes",
    ["秒"]: "seconds"
  }
};
